<mat-toolbar mat-dialog-title>
  <div></div>
  <div style="flex-grow: 1"></div>
  <mat-icon mat-dialog-close>close</mat-icon>
</mat-toolbar>

<mat-dialog-content>
  @if (url) {
    <iframe
      [frameBorder]="0"
      [height]="height"
      [src]="url"
      allowfullscreen
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      style="width: 100%"
    ></iframe>
  } @else {
    <p>{{ 'Loading_tr' | translate }}</p>
  }
</mat-dialog-content>
